import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class ForeignEmbassyValidatorService {
  public isForeignEmbassy:BehaviorSubject<any> = new BehaviorSubject(null);
  constructor() { }

  sendForeign(value: any,) {
    this.isForeignEmbassy.next({ isForeign: value });
  }


  getForeign(): Observable<any> {
    return this.isForeignEmbassy.asObservable();
  }
}
